export const MIN_PLAYER_COUNT = 3;
export const MAX_PLAYER_COUNT = 12;

export interface PlayerCountRules {
  readonly totalRaces: number;
  readonly coinsPerCharacter: number;
}

const LARGE_GAME_THRESHOLD = 7;

export function validatePlayerCount(playerCount: number): void {
  if (playerCount < MIN_PLAYER_COUNT || playerCount > MAX_PLAYER_COUNT) {
    throw new Error(
      `Player count must be between ${MIN_PLAYER_COUNT} and ${MAX_PLAYER_COUNT}, got ${playerCount}`,
    );
  }
}

export function getPlayerCountRules(playerCount: number): PlayerCountRules {
  validatePlayerCount(playerCount);

  return {
    totalRaces: playerCount < LARGE_GAME_THRESHOLD ? 3 : 2,
    coinsPerCharacter: playerCount < LARGE_GAME_THRESHOLD ? 5 : 7,
  };
}

// ≤5-player games use the few-player variant: extra pool tokens + a 2nd draw
// pass per round (with forfeit restricted to the 2nd pass).
export function isFewPlayerVariant(playerCount: number): boolean {
  return playerCount <= 5;
}

export function canForfeit(playerCount: number): boolean {
  // Official: forfeit (the last-player card) is a base mechanic available at any
  // player count. (For ≤5 players the few-player variant restricts it to the 2nd
  // draw pass — enforced there, not here.)
  validatePlayerCount(playerCount);
  return true;
}
